import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';

const OperationsPage: React.FC = () => {
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('operations')));

    return (
        <div className="fx-c h-100">
            <Header title={t('operations')} isDateVisible={false}></Header>
        </div>
    );
};

export default OperationsPage;
